import axios from "axios";
import { takeLatest, takeEvery, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../../utils/queryParams.js";
import moment from "moment/moment";

export const SET_LOADING = "saga/SET_LOADING";
export const SET_CONSTANTS = "saga/SET_CONSTANTS";
export const FETCH_MODULE = "saga/FETCH_MODULE";
export const TOGGLE_VIEW = "saga/TOGGLE_VIEW";
export const FETCH_FILTERS = "saga/FETCH_FILTERS";
export const UPDATE_FILTERS = "saga/UPDATE_FILTERS";
// keep it small to match reducer names and tags from backend props
export const LEAD_CONVERSION = "leadConversion";
export const NUM_OF_INTROS = "numOfIntros";
export const INTRO_REVENUE = "introRevenue";
export const REFERRAL_BY_SOURCE = "referralBySource";
export const TOTAL_REVENUE = "totalRevenue";

export const actionCreators = {
  fetchData: createAction(FETCH_MODULE),
  toggleView: createAction(TOGGLE_VIEW),
  updateFilters: createAction(UPDATE_FILTERS)
  // fetchFilters: createAction(FETCH_FILTERS)
};

export default function* watchStars() {
  yield takeEvery(FETCH_MODULE, fetchData);
  yield takeEvery(TOGGLE_VIEW, toggleView);
  yield takeEvery(UPDATE_FILTERS, updateFilters);
  // yield takeEvery(FETCH_FILTERS, fetchFilters);
}

function apiCall(route, params, method = axios.get) {
  return call(
    method,
    queryParams.apiVersion +
      route +
      Object.keys(params).reduce(
        (res, propName) => res + propName + "=" + params[propName] + "&",
        "?"
      )
  );
}

export function* fetchData({ payload }) {
  const { moduleName, constants, params: parameters, filters } = payload;
  // display loading visually to hide charts and filters while performing fetch
  yield put({ type: SET_LOADING + "/" + moduleName, payload: true });
  // adding constants (that contain organizationId, objectId, dataPath ...) to reducers on initial fetch
  if (constants) {
    yield put({
      type: SET_CONSTANTS + "/" + moduleName,
      payload: { ...constants, ...parameters }
    });
  }

  const {
    organizationId,
    objectId,
    locationId,
    regionId,
    filtersPath,
    dataPath,
    isTable,
    params: param
  } = yield select((state) => state[moduleName]);
  const endDate = param?.calendarEndDate;
  const startDate = moment(endDate).startOf("month").subtract(11, "month").format("YYYY-MM-DD");
  // build params object to make api calls
  let params = {
    organization_id: organizationId,
    object_id: objectId,
    location_id: locationId,
    region_id: regionId,
    start_date: startDate,
    end_date: endDate
  };

  try {
    // if we have filters we are updating chart with selected filters
    // otherwise we are performing initial fetch or reseting filters to initial params
    if (filters) {
      const {
        startDate: start_date,
        endDate: end_date,
        periodType,
        compareType,
        compareDates,
        referralValues
      } = filters;

      // update params constant with new filter parameters in the future
      params = {
        ...params,
        start_date,
        end_date,
        table_view: isTable,
        compare: compareDates,
        period_type: periodType.toLowerCase(),
        compare_type: compareType.id,
        categories: referralValues?.map(({ id }) => id).join(",")
      };
    } else {
      // fetching filters and updating filter values in the redux store
      const { start_date, end_date } = yield fetchFilters({
        payload: { moduleName, params, filtersPath }
      });

      // update params with new dates
      params = { ...params, start_date, end_date };
    }

    // fetch module data with params
    const { data } = yield apiCall(dataPath, params);

    // loading will be terminated on this yield
    yield put({
      type: FETCH_MODULE + "/" + moduleName,
      payload: data.data ? data.data : data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* fetchFilters({ payload }) {
  const { moduleName, params, filtersPath } = payload;

  const {
    data: { filters }
  } = yield apiCall(filtersPath, params);

  yield put({ type: FETCH_FILTERS + "/" + moduleName, payload: filters });
  return filters;
}

export function* updateFilters({ payload }) {
  const { moduleName, ...rest } = payload;

  yield put({ type: UPDATE_FILTERS + "/" + moduleName, payload: rest });
}

export function* toggleView({ payload }) {
  const { moduleName, view } = payload;

  yield put({ type: TOGGLE_VIEW + "/" + moduleName, payload: view });
  // refetch data for the table
  yield fetchData({ payload });
}
